import React from "react";
import "./style.sass";

const CasinoLoading = ({ loading }) => {
	if (!loading || window.TENANT === "betto") {
		return null;
	}

	return (
		<div className="bubbles">
			<div className="loading-dots">
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
				<div className="loading-dot"></div>
			</div>

			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg">
				<defs>
					<filter id="goo">
						<feGaussianBlur
							in="SourceGraphic"
							result="blur"
							stdDeviation="9"
						/>
						<feColorMatrix
							in="blur"
							mode="matrix"
							values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -7"
							result="goo"
						/>
						<feBlend
							in2="goo"
							in="SourceGraphic"
							result="mix"
						/>
					</filter>
				</defs>
			</svg>
		</div>
	);
};
export default CasinoLoading;
